import React, { useRef, useState, useEffect } from "react";

export default function Dropdown({
    label,
    id,
    placeholder,
    value,
    index,
    options,
    handleOnChangeInput,
    disabled,
    emptyField,
    data_testid,
    filterScroll,
    obj,
    objKey,
    widthAuto,
    searchDropdown,
}) {
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpen, setisOpen] = useState(false);

    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom - 40; // 40px
        const dropdownHeight = dropdownRef.current.clientHeight;

        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight - 22}px`;
        } else {
            dropdownRef.current.style.top = "105%";
        }
    };

    useEffect(() => {
        window.addEventListener("resize", calculateDropdownPosition);
        if (isOpen) calculateDropdownPosition(); // Calculate position when dropdown opens
        return () => {
            window.removeEventListener("resize", calculateDropdownPosition);
        };
    }, [isOpen]);

    const handleOptionClick = (option) => {
        handleOnChangeInput(id, option, index); // Trigger parent handler
        setisOpen(false); // Close dropdown
        buttonRef.current.focus(); // Refocus on the dropdown button
    };

    return (
        <>
            <div className="relative" ref={ref}>
                <p
                    htmlFor="countryCode"
                    className={`text-xs ${
                        searchDropdown
                            ? "font-normal pb-1"
                            : "font-semibold pb-1.5"
                    } text-[#000]`}
                >
                    {label}
                </p>
                <button
                    id={id}
                    type="button"
                    ref={buttonRef}
                    data-testid="select-device-btn"
                    onClick={() => setisOpen(!isOpen)}
                    className={`border ${
                        emptyField ? "border-[#C81720]" : "border-[#C5C9DA]"
                    } rounded-lg ${
                        searchDropdown ? "px-2 py-1.5" : "px-3.5 py-[12px]"
                    } text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] 
                    outline-none bg-white flex justify-between items-center ${widthAuto ? "w-auto" : "w-full"}`}
                    disabled={disabled}
                >
                    <p className={`${placeholder !== "Day(s)" &&
                            (value === "" ||
                                value === undefined ||
                                value === true ||
                                value.length === 0)
                        ? `text-[#52555D] ${searchDropdown ? "text-[13px] leading-[22px]" : ""}`
                        : searchDropdown ? "text-[#000000] text-[13px] leading-[22px]": "text-[#000B17]"
                    } text-start more-lines`}>
                        {value === "" ||
                            value === undefined ||
                            value === true ||
                            value.length === 0
                            ? placeholder
                            : value}
                    </p>

                    <img
                        loading="lazy"
                        decoding="async"
                        src="/images/dropdown_green.svg"
                        alt="icon"
                        className={`${searchDropdown ? "w-4 h-4" : "w-auto"} ${isOpen ? "transform rotate-180" : ""}`}
                    />
                </button>
                <ul
                    className={`${
                        searchDropdown ? "p-2" : "p-4"
                    } rounded-lg bg-white z-[9] absolute top-[72px] w-full min-w-max left-0 border border-[#C5C9DA] ${
                        isOpen ? "" : "hidden"
                    }`}
                    ref={dropdownRef}
                >
                    <li>
                        <ul
                            className={`max-h-[390px] overflow-auto  ${
                                filterScroll ? "scrollbar_gray" : "scrollBar_green"
                            }`}
                        >
                            {obj === undefined
                                ? options?.map((option, i) => (
                                    <li
                                        key={i}
                                        id={id}
                                        data_testid={id + i}
                                        onClick={() => handleOptionClick(option)}
                                    >
                                        <p
                                            className={`w-full inline-block cursor-pointer ${
                                                option === value && !searchDropdown
                                                    ? `text-base text-[#008586]`
                                                    : "text-[13px] leading-4 font-normal text-[#000000]"
                                            } hover:text-[#008586] ${
                                                options.length - 1 === i
                                                    ? ""
                                                    : searchDropdown
                                                        ? "mb-2"
                                                        : "mb-5"
                                            }`}
                                        >
                                            {option}
                                        </p>
                                    </li>
                                ))
                                : options?.map((option, i) => (
                                    <li
                                        key={i}
                                        data-testid="device_template"
                                        id={id}
                                        onClick={() => handleOptionClick(option)}
                                    >
                                        <p
                                            className={`w-full inline-block cursor-pointer ${
                                                option === value
                                                    ? `text-base text-[#008586]`
                                                    : "text-sm font-normal text-[#000]"
                                            } hover:text-[#008586] ${
                                                options.length - 1 === i ? "" : "mb-3"
                                            }`}
                                        >
                                            {option[objKey]}
                                        </p>
                                    </li>
                                ))}
                        </ul>
                    </li>
                </ul>
            </div>
        </>
    );
}
